import { RouteRecordRaw } from "vue-router";

// Lazy loading des composants pour améliorer les performances
const AfficheView = () => import("@/views/supports/AfficheView.vue");
const BanderoleView = () => import("@/views/supports/BanderoleView.vue");
const DepliantView = () => import("@/views/supports/DepliantView.vue");
const EmailingView = () => import("@/views/supports/EmailingView.vue");
const FlyerView = () => import("@/views/supports/FlyerView.vue");
const ReseauxView = () => import("@/views/supports/ReseauxView.vue");

export const supportRoutes: RouteRecordRaw[] = [
  {
    path: "supports/affiche/nouveau",
    name: "affiche-nouveau",
    component: AfficheView,
  },
  {
    path: "supports/affiche/:id",
    name: "affiche-edit",
    component: AfficheView,
    props: true,
  },
  {
    path: "supports/affiche/:id/edit",
    name: "affiche-edit-alias",
    component: AfficheView,
    props: true,
  },
  {
    path: "supports/flyer/nouveau",
    name: "flyer-nouveau",
    component: FlyerView,
  },
  {
    path: "supports/flyer/:id",
    name: "flyer-edit",
    component: FlyerView,
    props: true,
  },
  {
    path: "supports/flyer/:id/edit",
    name: "flyer-edit-alias",
    component: FlyerView,
    props: true,
  },
  {
    path: "supports/depliant/nouveau",
    name: "depliant-nouveau",
    component: DepliantView,
  },
  {
    path: "supports/depliant/:id",
    name: "depliant-edit",
    component: DepliantView,
    props: true,
  },
  {
    path: "supports/depliant/:id/edit",
    name: "depliant-edit-alias",
    component: DepliantView,
    props: true,
  },
  {
    path: "supports/banderole/nouveau",
    name: "banderole-nouveau",
    component: BanderoleView,
  },
  {
    path: "supports/banderole/:id",
    name: "banderole-edit",
    component: BanderoleView,
    props: true,
  },
  {
    path: "supports/banderole/:id/edit",
    name: "banderole-edit-alias",
    component: BanderoleView,
    props: true,
  },
  {
    path: "supports/emailing/nouveau",
    name: "emailing-nouveau",
    component: EmailingView,
  },
  {
    path: "supports/emailing/:id",
    name: "emailing-edit",
    component: EmailingView,
    props: true,
  },
  {
    path: "supports/emailing/:id/edit",
    name: "emailing-edit-alias",
    component: EmailingView,
    props: true,
  },
  {
    path: "supports/visuel-reseaux/nouveau",
    name: "visuel-reseaux-nouveau",
    component: ReseauxView,
  },
  {
    path: "supports/visuel-reseaux/:id",
    name: "visuel-reseaux-edit",
    component: ReseauxView,
    props: true,
  },
  {
    path: "supports/visuel-reseaux/:id/edit",
    name: "visuel-reseaux-edit-alias",
    component: ReseauxView,
    props: true,
  },
];
